import styled from 'styled-components';
import ReactLoadingSkeleton from 'react-loading-skeleton';

export const Skeleton = styled(ReactLoadingSkeleton)`
  border-radius: 16px;
`;
